"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import type { ApiProfileRepRatesState } from "@/entities/IProfile";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { useContext, useEffect, useMemo, useState } from "react";
import RepCategoryPill from "../RepCategoryPill";
import UserPageRepModifyModal from "../modify-rep/UserPageRepModifyModal";
import GrantRepDialog from "../new-rep/GrantRepDialog";
import { getCanEditRep, sortRepsByRatingAndContributors } from "../UserPageRep.helpers";
export default function UserPageRepHeader(t0) {
  const $ = _c(51);
  const {
    repRates,
    profile
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  repRates?.rating_stats;
  let t1;
  if ($[0] !== repRates?.rating_stats) {
    t1 = repRates?.rating_stats ?? [];
    $[0] = repRates?.rating_stats;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = sortRepsByRatingAndContributors(t1);
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const allReps = t2;
  const [visibleCount, setVisibleCount] = useState(5);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setVisibleCount(5);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = repRates?.rating_stats;
  let t5;
  if ($[5] !== t4) {
    t5 = [t4];
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  useEffect(t3, t5);
  const visibleReps = allReps.slice(0, visibleCount);
  const hasMore = allReps.length > visibleCount;
  let t6;
  if ($[7] !== activeProfileProxy || $[8] !== connectedProfile || $[9] !== profile) {
    t6 = getCanEditRep({
      myProfile: connectedProfile,
      targetProfile: profile,
      activeProfileProxy
    });
    $[7] = activeProfileProxy;
    $[8] = connectedProfile;
    $[9] = profile;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const canEditRep = t6;
  const [editCategory, setEditCategory] = useState(null);
  const [isGrantRepOpen, setIsGrantRepOpen] = useState(false);
  const t7 = "tw-relative tw-overflow-hidden tw-rounded-2xl tw-border tw-border-solid tw-border-white/[0.08] tw-bg-gradient-to-br tw-from-[#0f1014] tw-via-[#0A0A0C] tw-to-[#08090b] tw-shadow-2xl";
  let t10;
  let t11;
  let t8;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-blue-500/[0.05] tw-via-transparent tw-to-transparent tw-opacity-100" />;
    t9 = <div className="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-h-[1px] tw-bg-gradient-to-r tw-from-transparent tw-via-blue-400/40 tw-to-transparent" />;
    t10 = <div className="tw-absolute tw-bottom-0 tw-left-0 tw-top-0 tw-w-[1px] tw-bg-gradient-to-b tw-from-transparent tw-via-blue-400/20 tw-to-transparent" />;
    t11 = <div className="tw-absolute tw-bottom-0 tw-right-0 tw-top-0 tw-w-[1px] tw-bg-gradient-to-b tw-from-transparent tw-via-blue-400/20 tw-to-transparent" />;
    $[11] = t10;
    $[12] = t11;
    $[13] = t8;
    $[14] = t9;
  } else {
    t10 = $[11];
    t11 = $[12];
    t8 = $[13];
    t9 = $[14];
  }
  const t12 = "tw-relative tw-p-6";
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="tw-min-w-0"><h2 className="tw-mb-1 tw-text-xl tw-font-semibold tw-text-iron-100">Rep</h2><p className="tw-mb-0 tw-text-sm tw-font-normal tw-leading-relaxed tw-text-iron-500">What others recognize this identity for.</p></div>;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="tw-mb-1 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">Total Rep</div>;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== repRates) {
    t15 = repRates ? formatNumberWithCommas(repRates.total_rep_rating) : "";
    $[17] = repRates;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== t15) {
    t16 = <div className="tw-text-3xl tw-font-semibold tw-leading-none tw-tracking-tight tw-text-primary-400">{t15}</div>;
    $[19] = t15;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== repRates) {
    t17 = repRates && <span className="tw-mt-1 tw-text-sm tw-font-normal tw-text-iron-400">{formatNumberWithCommas(repRates.number_of_raters)}{" "}{repRates.number_of_raters === 1 ? "rater" : "raters"}</span>;
    $[21] = repRates;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== t16 || $[24] !== t17) {
    t18 = <div className="tw-flex tw-items-start tw-justify-between tw-gap-6">{t13}<div className="tw-flex tw-flex-shrink-0 tw-flex-col tw-items-end tw-text-right">{t14}{t16}{t17}</div></div>;
    $[23] = t16;
    $[24] = t17;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  const t19 = (visibleReps.length > 0 || canEditRep) && <div className="tw-mt-6 tw-border-b-0 tw-border-l-0 tw-border-r-0 tw-border-t tw-border-solid tw-border-white/10 tw-pt-6"><div className="tw-mb-4 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">Rep Categories</div><div className="tw-flex tw-flex-wrap tw-gap-3">{canEditRep && <button type="button" onClick={() => setIsGrantRepOpen(true)} className="tw-group tw-inline-flex tw-h-11 tw-cursor-pointer tw-items-center tw-justify-center tw-gap-x-1.5 tw-rounded-lg tw-border tw-border-dashed tw-border-white/15 tw-bg-white/[0.03] tw-px-4 tw-text-sm tw-font-medium tw-text-iron-400 tw-transition-all tw-duration-300 tw-ease-out hover:tw-border-white/20 hover:tw-bg-white/[0.05] hover:tw-text-iron-300"><svg className="-tw-ml-1 tw-h-4 tw-w-4 tw-text-iron-400 tw-transition-colors group-hover:tw-text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14" /></svg><span>Add new</span></button>}{visibleReps.map(rep => <RepCategoryPill key={rep.category} rep={rep} profileHandle={profile.handle ?? ""} canEdit={canEditRep} onEdit={setEditCategory} />)}{hasMore && <button type="button" onClick={() => setVisibleCount(_temp)} className="tw-inline-flex tw-h-11 tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-white/5 tw-px-4 tw-text-sm tw-font-medium tw-text-iron-400 tw-backdrop-blur-md tw-transition-all tw-duration-300 tw-ease-out hover:tw-border-white/20 hover:tw-bg-white/10 hover:tw-text-white">+{allReps.length - visibleCount} more</button>}</div></div>;
  let t20;
  if ($[26] !== t18 || $[27] !== t19) {
    t20 = <div className={t12}>{t18}{t19}</div>;
    $[26] = t18;
    $[27] = t19;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== t10 || $[30] !== t11 || $[31] !== t20 || $[32] !== t8 || $[33] !== t9) {
    t21 = <div className={t7}>{t8}{t9}{t10}{t11}{t20}</div>;
    $[29] = t10;
    $[30] = t11;
    $[31] = t20;
    $[32] = t8;
    $[33] = t9;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== canEditRep || $[36] !== editCategory || $[37] !== profile || $[38] !== setEditCategory) {
    t22 = canEditRep && editCategory && <UserPageRepModifyModal profile={profile} category={editCategory} onClose={() => setEditCategory(null)} />;
    $[35] = canEditRep;
    $[36] = editCategory;
    $[37] = profile;
    $[38] = setEditCategory;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== setIsGrantRepOpen) {
    t23 = () => setIsGrantRepOpen(false);
    $[40] = setIsGrantRepOpen;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== isGrantRepOpen || $[43] !== profile || $[44] !== repRates || $[45] !== t23) {
    t24 = <GrantRepDialog profile={profile} repRates={repRates} isOpen={isGrantRepOpen} onClose={t23} />;
    $[42] = isGrantRepOpen;
    $[43] = profile;
    $[44] = repRates;
    $[45] = t23;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== t21 || $[48] !== t22 || $[49] !== t24) {
    t25 = <>{t21}{t22}{t24}</>;
    $[47] = t21;
    $[48] = t22;
    $[49] = t24;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  return t25;
}
function _temp(prev) {
  return prev + 10;
}